import React, {useEffect, useState} from 'react';
import {styles} from './actionItems_styles.web';
import {ActionItemsProps} from './actionItems_types.web';
import InfoIcon from '../../Icons/icons/info';
import {useTheme} from '../../../../utils/theming/themeProvider';
import HeadingContainer from '../../Headings/HeadingContainer/HeadingContainer.web';

const ActionItems = (props: React.PropsWithChildren<ActionItemsProps>) => {
  // Props
  const {
    id,
    className,
    color = 'black',
    headingContainer,
    leading = 'icon',
    LeadingIcon,
    leadingSize = '24',
    leadingAlign = 'left',
    image,
    containerStyle,
    onClick,
  } = props;

  // Styles
  const {colors, fontStyles} = useTheme();
  const [imageType, setImageType] = useState('even');

  const generalStyles = styles();

  const imageClass = {
    even: generalStyles.squareImage,
    landscape: generalStyles.landscapeImage,
    portrait: generalStyles.portraitImage,
  };

  const colorLeadingIcon =
    color === 'gray'
      ? colors.neutral600
      : color === 'purple'
      ? colors.primary700
      : color === 'white'
      ? colors.neutral1000
      : colors.neutral1000;

  function getImageOrientation(url: string) {
    let img = new Image();
    img.src = url;

    if (img.naturalWidth > img.naturalHeight) {
      setImageType('landscape');
    } else if (img.naturalWidth < img.naturalHeight) {
      setImageType('portrait');
    } else {
      setImageType('even');
    }
  }

  useEffect(() => {
    if (image?.length) {
      getImageOrientation(image);
    }
  }, [image]);

  return (
    <div
      id={id}
      className={className}
      style={{
        ...generalStyles.actionItemsContainer,
        flexDirection: leadingAlign === 'right' ? 'row-reverse' : 'row',
        ...containerStyle,
      }}
      onClick={onClick}>
      {LeadingIcon && leading === 'icon' ? (
        <LeadingIcon size={leadingSize} color={colorLeadingIcon} />
      ) : leading === 'image' && image?.length ? (
        <div style={{...generalStyles.imageContainer}}>
          <img
            style={{
              ...imageClass[imageType as keyof typeof imageClass],
            }}
            src={image}
          />
        </div>
      ) : null}
      <HeadingContainer {...headingContainer} />
    </div>
  );
};

export default ActionItems;
